import React from "react";

import { ColorswatchFacetDisplayValue } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/ColorswatchFacet/colorswatchFacet.container";
import { ColorswatchFacetValueComponent } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/ColorswatchFacet/colorswatchFacetValue.component";

import "./colorswatch.scss";

type ColorswatchFacetComponentProps = {
    values: Array<ColorswatchFacetDisplayValue>;
};

const ColorswatchFacetComponent = ({
    values,
}: ColorswatchFacetComponentProps) => {
    return (
        <ul
            className={
                "colorswatch d-flex flex-wrap position-relative list-unstyled"
            }
        >
            {values.map(value => (
                <ColorswatchFacetValueComponent
                    key={`${value.label}-${value.refined}`}
                    value={value}
                />
            ))}
        </ul>
    );
};

export { ColorswatchFacetComponent };
